module.exports = __webpack_public_path__ + "static/media/info.f1da0454.png";